import { Column } from 'react-table';

import { Grid, Typography } from '@mui/material';

import IndexTable from 'src/components/Commons/Table/index-table';
import { useQuery } from 'react-query';
import { getPageMessageStatistic } from 'src/apis/Reports/report.api';
import { useMemo } from 'react';
import { convertNumberToString } from 'src/utils/commons/number';
import { PageMessageStatisticQuery, ReportPageMessageStatistic } from 'src/types/Reports/pageReport.model';
import { formatDate } from 'src/utils/commons/date';

type PageMessageStatisticTableProps = {
  params: PageMessageStatisticQuery;
};

const PageMessageStatisticTable = ({ params }: PageMessageStatisticTableProps) => {
  const { isLoading, data } = useQuery([params], () => getPageMessageStatistic(params), { cacheTime: 0 });

  const columns = useMemo(
    () =>
      [
        {
          Header: 'Page',
          accessor: 'name',
          width: 60,
          Cell: cell => (
            <Typography fontWeight="bold" color="darkgreen">
              {cell.row.original.name}
            </Typography>
          )
        },
        {
          Header: 'Id',
          accessor: 'sourceId',
          width: 60,
          Cell: cell => <Typography fontWeight="bold">{cell.row.original.sourceId}</Typography>
        },

        {
          Header: () => {
            return <div className="flex justify-start">Số tin nhắn</div>;
          },
          accessor: 'newInboxCount',
          width: 150,
          Cell: cell => (
            <Typography fontWeight="bold">{convertNumberToString(cell.row.original.newInboxCount)}</Typography>
          )
        },
        {
          Header: () => {
            return <div className="flex justify-start">Số điện thoại</div>;
          },
          accessor: 'phoneNumberCount',
          width: 150,
          Cell: cell => <Typography fontWeight="bold">{Math.round(cell.row.original.phoneNumberCount)}</Typography>
        },
        {
          Header: () => {
            return <div className="flex justify-start">Tỷ lệ</div>;
          },
          accessor: 'percent',
          width: 150,
          Cell: cell => <Typography fontWeight="bold">{cell.row.original.percent}%</Typography>
        }
      ] as Column<ReportPageMessageStatistic>[],

    []
  );
  return (
    <Grid spacing={0} container className="pt-16 block">
      <IndexTable
        columns={columns}
        data={data?.data || []}
        loading={isLoading}
        pageCount={data?.data?.length || 0}
        totalDataCount={data?.data?.length || 0}
        searchText=""
        location={location}
        history={history}
        filters={params}
        setFilters={() => {}}
      />
    </Grid>
  );
};

export default PageMessageStatisticTable;
